import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl  } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import {UsiService } from 'src/app/_services/usi/usi.service'

@Component({
  selector: 'app-usit',
  templateUrl: './usit.component.html',
  styleUrls: ['./usit.component.scss']
})
export class UsitComponent implements OnInit {
  usiForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any;
   tenantId: string;
    currentUser: any;
    selectedFile: File;
    form: FormGroup;
    emailPattern = "^[a-z0-9._%+-]+\\.[a-z]{2,4}$";
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = []
    deleteConfirmationMsg = 'Are you sure you want to delete'

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private usiservice: UsiService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };

    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.usiForm = new FormGroup({
      id : new FormControl('',[Validators.required]),
      title :  new FormControl(''),
      version : new FormControl(''),
      issue :  new FormControl('',[Validators.required]),
      model :  new FormControl('',[Validators.required]),
      buildPhase :  new FormControl(''),
      sopset :  new FormControl(''),
      riskA :  new FormControl(''),
      riskB :  new FormControl(''),
      riskC :  new FormControl(''),
      infoD :  new FormControl(''),
      upgradeNecessary :  new FormControl(''),
      upgradeNotNecessary :  new FormControl(''),
      upgradeCenter :  new FormControl(''),
      workshopInstructions :  new FormControl(''),
      dir :  new FormControl(''),
      problemDescription :  new FormControl(''),
      recommendations :  new FormControl(''),
      affectedVehicles :  new FormControl(''),
      requiredActions : new FormControl(''),
      timeRequiredForUpgradeInHours : new FormControl(''),
      recurringCheckRequired : new FormControl(''),
      validUntil :  new FormControl(''),
      replacedBy :  new FormControl(''),
      contactPerson :  new FormControl(''),
      contactDepartmentCode :  new FormControl(''),
      contactPhoneNo :  new FormControl(''),
      contactEmailAddress :  new FormControl(''),
      managerPersion :  new FormControl(''),
      managerDepartmentCode :  new FormControl(''),
      managerPhoneNo : new FormControl(''),
      managerEmailAddress :  new FormControl(''),
      customerPerson : new FormControl(''),
      customerPhoneNo :  new FormControl(''),
      
    })

   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getusiData();
  }


  getusiData() {
    this.usiservice.getAllUsiTemplates().subscribe((response: any) => {
      this.rowData = response.result;
    }); 
  }

   // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
   onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  } 

  private createColumnDefs() {
    return [
    {
      headerName: 'Title',
      field: 'title',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'Issue',
      field: 'issue',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Model',
      field: 'model',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Problem Description',
      field: 'problemDescription',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Build Phase',
      field: 'buildPhase',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Sop Set',
      field: 'sopset',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Risk',
      field: 'risk',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Recommendations',
      field: 'recommendations',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Affected Vehicles',
      field: 'affectedVehicles',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Required Actions',
      field: 'requiredActions',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contact Person',
      field: 'contactPerson',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contact Department Code',
      field: 'contactDepartmentCode',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contact PhoneNo',
      field: 'contactPhoneNo',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Contact Email Address',
      field: 'contactEmailAddress',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
  ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createUSI() {
    let details = JSON.stringify(this.usiForm.value);
    this.usiservice.createUsiTemplates(details).subscribe(response => {
      console.log("response: ", response);
      
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.usiForm.controls;
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.usiservice.deleteUsiTemplates(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.usiForm.patchValue(this.selectedCheckboxData[0])
  }


  createOpenModal() {
    this.modeAction = 1;
    this.usiForm.reset();
    this.usiForm.patchValue({
      id : '',
      title :  '',
      version : '',
      issue :  '',
      model :  '',
      buildPhase :  '',
      sopset :  '',
      riskA :   '',
      riskB :   '',
      riskC :   '',
      infoD :   '',
      upgradeNecessary :   '',
      upgradeNotNecessary :   '',
      upgradeCenter :   '',
      workshopInstructions :   '',
      dir :   '',
      problemDescription :   '',
      recommendations :   '',
      affectedVehicles :   '',
      requiredActions :   '',
      timeRequiredForUpgradeInHours : '',
      recurringCheckRequired : '',
      validUntil :  '',
      replacedBy :   '',
      contactPerson :   '',
      contactDepartmentCode :   '',
      contactPhoneNo :   '',
      contactEmailAddress :   '',
      managerPersion :   '',
      managerDepartmentCode :   '',
      managerPhoneNo :   '',
      managerEmailAddress :   '',
      customerPerson :   '',
      customerPhoneNo :   '',
      customerEmailAddress :   '',
      
    })
  }

  updateusi() {
    this.usiservice.updateUsiTemplates(this.usiForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getusiData();
      this.selectedCheckboxData = []
      $('#closeCreateModal').trigger("click");
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].title} ${this.selectedCheckboxData[i].issue}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].title} ${this.selectedCheckboxData[i].issue}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].title} ${this.selectedCheckboxData[i].issue}`;
    }
  }

  deleteUsiList() {
    this.usiservice.deleteUsiTemplates(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getusiData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteLead').trigger("click");
    });
  }

}
